export const ListQueryKey = 'sbLtHyzs';
export const DetailQueryKey = 'sbLtHyz';

export const Urls = {
  selectUrl: '/sbLtHyz/list',
  updateUrl: '/sbLtHyz/update',
  deleteUrl: '/sbLtHyz/delete',
  createUrl: '/sbLtHyz/create',
  detailUrl: '/sbLtHyz/info',
};
